import { render, staticRenderFns } from "./KT-CreateStaffing.vue?vue&type=template&id=b2b08c66&scoped=true&"
import script from "./KT-CreateStaffing.vue?vue&type=script&lang=js&"
export * from "./KT-CreateStaffing.vue?vue&type=script&lang=js&"
import style0 from "./KT-CreateStaffing.vue?vue&type=style&index=0&id=b2b08c66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b08c66",
  null
  
)

export default component.exports